<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>{{ boxTitle }}</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-2">
								<div class="form-group">
									<label>Código</label>
									<input v-validate="'required'" name="codigo" v-mask="'##.##.##.###-#'" v-model="dados.codigo" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('codigo') }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Nome</label>
									<input v-validate="'required'" name="nome" v-model="dados.nome" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('nome') }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Tipo de atendimento</label>
									<select v-validate="'required'" name="tipo-de-atendimento" v-model="dados.tipo_atendimento" class="form-control">
										<option :value="TIPO_ATENDIMENTO.INDIVIDUAL">Individual</option>
										<option :value="TIPO_ATENDIMENTO.AGRUPADO">Agrupado</option>
									</select>
									<span class="text-danger">{{ errors.first('tipo-de-atendimento') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Situação</label>
									<select  v-validate="'required'" name="situacao" v-model="dados.situacao" class="form-control">
										<option :value="SITUACAO.ATIVA">Ativo</option>
										<option :value="SITUACAO.INATIVA">Inativo</option>
									</select>
									<span class="text-danger">{{ errors.first('situacao') }}</span>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Tipo de agrupamento</label>
									<select v-model="dados.tipo_agrupamento" class="form-control">
										<option value="">Selecione o agrupamento...</option>
										<option :value="TIPO_AGRUPAMENTO.BIOQUIMICA">Bioquimica</option>
										<option :value="TIPO_AGRUPAMENTO.OFTALMOLOGIA">Oftalmologia</option>
									</select>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Sexo</label>
									<select v-validate="'required'" name="sexo" v-model="dados.sexo" class="form-control">
										<option :value="SEXO.AMBOS">Ambos</option>
										<option :value="SEXO.MASCULINO">Masculino</option>
										<option :value="SEXO.FEMININO">Feminino</option>
									</select>
									<span class="text-danger">{{ errors.first('situacao') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Qtd. máxima</label>
									<input maxlength="2" v-model="dados.quantidade_maxima" class="form-control" type="number">
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Idade mínima</label>
									<input maxlength="2" v-model="dados.idade_minima" class="form-control" type="number">
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Idade máxima</label>
									<input v-model="dados.idade_maxima" class="form-control" type="number">
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-3">
								<div class="form-group">
									<label>Valor de referência</label>
									<input v-validate="'required'" name="valor-de-referencia" v-model="dados.valor_referencia" class="form-control" type="number">
									<span class="text-danger">{{ errors.first('valor-de-referencia') }}</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="form-group">
									<label>Complexidade</label>
									<select v-model="dados.complexidade" class="form-control">
										<option value="">Selecione a complexidade...</option>
										<option :value="COMPLEXIDADE.BAIXA">Baixa</option>
										<option :value="COMPLEXIDADE.MEDIA">Média</option>
										<option :value="COMPLEXIDADE.ALTA">Alta</option>
									</select>
								</div>
							</div>
							<div class="col-md-3">
								<div class="form-group">
									<label>Tipo de financiamento</label>
									<select v-model="dados.tipo_financiamento" class="form-control">
										<option value="">Selecione tipo de financiamento...</option>
										<option :value="TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA_E_MAC">Assistência farmacêutica e MAC</option>
										<option :value="TIPO_FINANCIAMENTO.FAEC">FAEC - FUNDO DE Ações estratégicas e compensações</option>
										<option :value="TIPO_FINANCIAMENTO.INCENTIVO">Incentivo - MAC</option>
										<option :value="TIPO_FINANCIAMENTO.MAC">MAC - Média e alta complexidade</option>
										<option :value="TIPO_FINANCIAMENTO.VIGILANCIA">Vigilância em saude</option>
										<option :value="TIPO_FINANCIAMENTO.AB">AB - Atenção Básica</option>
										<option :value="TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA">Assistência farmacêutica</option>
									</select>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Forma de organização</label>
									<select v-validate="'required'" name="forma-de-organizacao" v-model="dados.procedimento_forma_organizacao_id" class="form-control">
										<option value="">Selecione a forma de organização...</option>
										<option v-for="(formaOrganizacao, index) in formasOrganizacao" :key="index" :value="formaOrganizacao.id">{{formaOrganizacao.codigo}} - {{formaOrganizacao.nome}}</option>
									</select>
									<span class="text-danger">{{ errors.first('forma-de-organizacao') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"> <i class="fa fa-reply"></i> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import {mask} from 'vue-the-mask';
	import {
		SEXO,
		SITUACAO,
		TIPO_ATENDIMENTO,
		TIPO_AGRUPAMENTO,
		COMPLEXIDADE,
		TIPO_FINANCIAMENTO
	} from "@/constants";
	export default {
		directives: {mask},
		inject: ["$validator"],
		computed: {
			SEXO: function() {
				return SEXO;
			},
			SITUACAO: function() {
				return SITUACAO;
			},
			TIPO_ATENDIMENTO: function() {
				return TIPO_ATENDIMENTO;
			},
			TIPO_AGRUPAMENTO: function() {
				return TIPO_AGRUPAMENTO;
			},
			COMPLEXIDADE: function() {
				return COMPLEXIDADE;
			},
			TIPO_FINANCIAMENTO: function() {
				return TIPO_FINANCIAMENTO;
			},
		},
		data: () => ({
			dados: {
				nome: '',
				codigo: '',
				tipo_atendimento: 0,
				situacao: 1,
				tipo_agrupamento: '',
				sexo: 0,
				quantidade_maxima: 0,
				idade_minima: '',
				idade_maxima: '',
				valor_referencia: '',
				complexidade: '',
				tipo_financiamento: '',
				procedimento_forma_organizacao_id: '',
			},
			formasOrganizacao: [],
			procedimentoId: "",
			boxTitle: "Novo Procedimento"
		}),
		mounted() {
			this.procedimentoId = this.$route.params.procedimentoId;
			if (this.procedimentoId) {
				this.boxTitle = "Editar Procedimento";
				this.getProcedimento(this.procedimentoId);
			}
			this.getFormasOrganizacao();
		},
		methods: {
			getFormasOrganizacao() {
				axios
					.get(`${this.$store.state.serverURI}/api/cadastros/formas-organizacao-procedimento/getAll`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.formasOrganizacao = response.data;
					})
					.catch(error => {
						console.log(error);
					});
			},
			getProcedimento(procedimentoId) {
				axios
					.get(`${this.$store.state.serverURI}/api/cadastros/procedimentos/getById/${this.procedimentoId}`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.dados = response.data;
						// this.dados.codigo = this.dados.codigo.split(".")[3];
					})
					.catch(error => {
						console.log(error);
					});
			},
			salvar() {
				this.$validator.validate().then(result => {
					if (result) {
						if (this.procedimentoId) {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/procedimentos/update/${this.procedimentoId}`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Procedimento atualizado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/procedimentos/");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						} else {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/procedimentos/create`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Procedimento criado com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/procedimentos");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						}
					}
				});
			}
		},
		watch: {},
		components: {}
	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// form.vue?85480030